import { camelCase } from "lodash";
import { useEffect } from "react";

export function usePerformActionFromUrl<ActionType>({
  onAction = () => {},
  removeActionFromUrl = true,
}: {
  onAction?: (action: ActionType, params: Record<string, string>) => void;
  removeActionFromUrl?: boolean;
}) {
  useEffect(() => {
    const url = new URL(window.location.href);
    const action = url.searchParams.get("action") as ActionType; // May or may not be an ActionType, caller is responsible for checking
    const actionParams = Array.from(url.searchParams.entries()).reduce(
      (params, [key, value]) => {
        if (key.startsWith("action:")) {
          params[camelCase(key.replaceAll("action:", ""))] = value;
        }
        return params;
      },
      {} as Record<string, string>,
    );

    if (action) {
      onAction(action, actionParams);
      // Optionally, you can remove the action from the URL after performing it
      if (removeActionFromUrl) {
        url.searchParams.delete("action");
        Array.from(url.searchParams.keys()).forEach((key) => {
          if (key.startsWith("action:")) {
            url.searchParams.delete(key);
          }
        });
        window.history.replaceState({}, "", url.toString());
      }
    }
  }, []);
}
